import { useFetchDocumentYearsQuery } from "../../../redux";

const useDocumentYearsList = (slug) => {
    const data = useFetchDocumentYearsQuery({ slug });
    return {
        ...data
    };
};

export default useDocumentYearsList;